import { ICommit, IPagination, IRepository, IRepositoryEntry, IResourceVersion } from '@/types';
import { findReadmeInFolder } from '@/lib/repositoryFolderApi';

import { Stack } from '@/ui/primatives';

import Pagination from '@/components/Pagination';

import DirectoryEntry from './DirectoryEntry';
import FileView from '@/components/Repository/FileView';
import Cardlist from '@/ui/CardList';

const generateParentFolderEntry = (folderPath: string) => {
  const isRootFolder = folderPath === '';
  const parentFolder = isRootFolder ? null : folderPath.split('/').slice(0, -1).join('/') || '/';
  const parentFolderEntry: IRepositoryEntry | undefined = parentFolder
    ? {
        filename: parentFolder,
        data_type: 'dir',
        is_dir: true,
        latest_commit: null as unknown as ICommit,
        size: -1,
      }
    : undefined;
  return parentFolderEntry;
};

const RepositoryFolderView: React.FC<{
  repository: IRepository;
  entries?: IRepositoryEntry[];
  pagination?: IPagination;
  resource: IResourceVersion;
  children?: React.ReactNode;
}> = ({ repository, entries = [], pagination, resource, children }) => {
  const readmeFileEntry = (entries && findReadmeInFolder(entries)) || null;
  const parentFolderEntry = generateParentFolderEntry(resource?.path || '');

  return (
    <Stack gap={25}>
      <Cardlist compressed>
        {children}
        {parentFolderEntry && (
          <DirectoryEntry
            repository={repository}
            entry={parentFolderEntry}
            branch={resource?.version || 'main'}
            folderPath=""
            filenameOverride=". . ."
          />
        )}
        {entries.map((entry) => (
          <DirectoryEntry
            key={entry.filename}
            entry={entry}
            repository={repository}
            branch={resource?.version || 'main'}
            folderPath={resource?.path}
          />
        ))}
      </Cardlist>
      {pagination && pagination.total_pages > 1 && <Pagination pagination={pagination} />}
      {readmeFileEntry && <FileView repository={repository} entry={readmeFileEntry} />}
    </Stack>
  );
};

export default RepositoryFolderView;
